import { Component, OnInit, ViewChild, Inject } from '@angular/core';
import { MatPaginator, MatTableDataSource, MatDialogRef, MAT_DIALOG_DATA, MatDialog } from '@angular/material';
import { Router } from '@angular/router';
import { AlertsService } from '../../alerts.service';

@Component({
  selector: 'app-alert-dialog',
  templateUrl: './alert-dialog.component.html',
  styleUrls: ['./alert-dialog.component.scss']
})
export class AlertDialogComponent implements OnInit {

  alertColumns = ['siteCustomerName', 'positionDate', 'shift', 'createdTime', 'link'];
  alertItems: any[] = new Array();
  alertDataSource;
  @ViewChild(MatPaginator) paginator: MatPaginator;


  constructor(
    private alertService: AlertsService,
    public dialogRef: MatDialogRef<AlertDialogComponent>,
    @Inject(MAT_DIALOG_DATA) public info: any,
    public dialog: MatDialog,
    private router: Router
  ) { }

  ngOnInit() {
    this.alertService.getAlerts()
      .subscribe((data) => {
        this.alertItems = data;
        this.alertDataSource = new MatTableDataSource<any>(this.alertItems);
        this.alertDataSource.paginator = this.paginator;
    });
  }

  resolve(date: any, site: any) {
    localStorage.setItem('selectedDate', date);
    if (site.indexOf('/') > -1) {
      site = site.replace(/\//g, '#2F');
      this.router.navigate(['shifts/' + site]);
    } else {
      this.router.navigate(['shifts/' + site]);
    }
    this.closeClicked();
  }

  closeClicked() {
    this.dialogRef.close({result: 'cancelled'});
  }
}
